/**
 * Contrato da exclusão de conta (fase 1).
 * Ver ftcloud-api/docs/integracoes/frontend-angular/ANGULAR_EXCLUSAO_DE_CONTA.md.
 */

/** Estados que o front enxerga (a API nunca expõe PD/RM). */
export type AccountStatus = 'active' | 'pending_deletion';

/** POST /user/{userID}/deletion — corpo. */
export interface AccountDeletionRequest {
  confirmationEmail: string;
}

/**
 * Resposta de POST, GET e DELETE /user/{userID}/deletion (200).
 * Sem pedido: { status: 'active', requestedAt: null, scheduledAt: null }.
 */
export interface AccountDeletionStatus {
  status: AccountStatus;
  requestedAt: string | null;
  scheduledAt: string | null;
}

/** 400 do POST. */
export interface ConfirmationEmailMismatchError {
  error: 'confirmation_email_mismatch';
}

/** 404 do DELETE quando não há pedido pendente. */
export interface NoPendingDeletionError {
  error: 'no_pending_deletion';
}

/** 403 dos três endpoints para token de dispositivo ou tuner afiliado. */
export interface SelfOnlyError {
  error: 'forbidden';
  code: 'self_only';
}

/** 403 global durante a carência (tratado no interceptor). */
export interface PendingDeletionForbidden {
  error: 'account.pending_deletion';
  deletionScheduledAt: string | null;
}

export function isPendingDeletionForbidden(body: unknown): body is PendingDeletionForbidden {
  return (
    typeof body === 'object' &&
    body !== null &&
    (body as { error?: unknown }).error === 'account.pending_deletion'
  );
}
